import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";

const ClientSearchBar = (props) => {
	const [clientList, setClientList] = useState([]);
	const [search, setSearch] = useState("");
	const [clientPagination, setClientPagination] = useState({
		currentPage: 1,
		totalPages: 1,
		hasNext: false,
		isLoading: false,
	});
	const { t } = useTranslation();

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			SearchClients();
		}, 300);

		return () => clearTimeout(timeoutId);
	}, [search]);

	useEffect(() => {
		const handleScroll = (event) => {
			const { target } = event;
			if (
				target &&
				target.classList &&
				target.classList.contains("MuiAutocomplete-listbox")
			) {
				const { scrollTop, scrollHeight, clientHeight } = target;
				if (scrollTop + clientHeight >= scrollHeight - 10) {
					loadMoreClients();
				}
			}
		};

		document.addEventListener("scroll", handleScroll, true);

		return () => {
			document.removeEventListener("scroll", handleScroll, true);
		};
	}, [
		clientPagination.hasNext,
		clientPagination.isLoading,
		clientPagination.currentPage,
	]);

	const SearchClients = (page = 1, append = false) => {
		const is_on_advanced_plan = props.isStaff ? props.isStaff : false;
		if (search !== "") {
			setClientPagination((prev) => ({ ...prev, isLoading: true }));

			props
				.getClientList("active", search, is_on_advanced_plan, page)
				.then((res) => {
					if (append) {
						setClientList((prev) => [...prev, ...res.results]);
					} else {
						setClientList(res.results);
					}
					const totalPages = Math.ceil(res.count / 20);
					setClientPagination({
						currentPage: res.current_page,
						totalPages: totalPages,
						hasNext: !!res.next,
						isLoading: false,
					});
				})
				.catch((err) => {
					console.log(err);
					setClientPagination((prev) => ({ ...prev, isLoading: false }));
				});
		} else {
			setClientList([]);
			setClientPagination({
				currentPage: 1,
				totalPages: 1,
				hasNext: false,
				isLoading: false,
			});
		}
	};

	const loadMoreClients = () => {
		if (clientPagination.hasNext && !clientPagination.isLoading) {
			const nextPage = clientPagination.currentPage + 1;
			SearchClients(nextPage, true);
		}
	};

	const handleOnChange = (e) => {
		if (e.target.value) {
			setSearch(e.target.value);
		} else {
			setSearch("");
		}
	};

	const getOptionLabel = (option, showClientId) => {
		if (showClientId && option.client_name) {
			return `${option.client_name} #(${option.id}) (${option.rb_client_type})`;
		}

		if (option.client_name && option.rb_client_type) {
			return `${option.client_name} (${option.rb_client_type})`;
		}

		return "";
	};

	return (
		<Tooltip
			placement="bottom-start"
			title={!clientList.length ? t("type_to_search_clients") : ""}
		>
			<Autocomplete
				options={search !== "" ? clientList : []}
				filterOptions={(options) => options}
				disablePortal={true}
				blurOnSelect={true}
				value={props.value}
				noOptionsText={
					search !== "" ? t("no_results_found") : t("enter_char_to_search")
				}
				disableClearable={!props.clearable == true}
				getOptionLabel={(option) => getOptionLabel(option, props.showClientId)}
				onClose={(e) => {
					e.preventDefault();
				}}
				onChange={props.onChange}
				classes={props.classes}
				ListboxProps={{
					onScroll: (event) => {
						const { target } = event;
						const { scrollTop, scrollHeight, clientHeight } = target;
						if (scrollTop + clientHeight >= scrollHeight - 10) {
							loadMoreClients();
						}
					},
				}}
				renderInput={(params) => {
					return (
						<TextField
							{...params}
							onChange={handleOnChange}
							success={props.clientState === "success"}
							error={props.clientState === "error"}
							label={t("search_client_label")}
							autoComplete="disabled"
							fullWidth
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<React.Fragment>
										{clientPagination.isLoading ? (
											<CircularProgress
												size={18}
												style={{ color: "#6F57E9" }}
											/>
										) : null}
										{params.InputProps.endAdornment}
									</React.Fragment>
								),
							}}
						/>
					);
				}}
			/>
		</Tooltip>
	);
};

export default ClientSearchBar;
